<template>
	<div ref="mainContainerMiniChat" class="messages-full-view-mini fill-height" :class="{ 'chat-focused': chatFocused }">
		<div class="d-flex flex-column justify-center align-center fill-height flex-1" v-if="loadingRoomMessages">
			<div class="d-flex flex-column justify-center align-center fill-height flex-1">
				<v-progress-circular
					:size="30"
					:width="5"
					color="rgba(0,0,0,0.2)"
					class="mb-3"
					indeterminate
				></v-progress-circular>
				<p class="mb-0 caption">Cargando Mensajes</p>
			</div>
		</div>
		<div v-else-if="room" class="d-flex flex-column fill-height">
			<!-- Header de la sala -->
			<div class="chat-header" :class="{ 'project-line-header': getRoomTypeIndicator === 'project_line' }">
				<div class="d-flex align-center flex-1 flex-grow-1" style="width: 100%;">
					<div class="py-1 px-1 fill-height d-flex align-center justify-center pa-2" style="width: 75px;">
						<div class="text-center">
							<p class="mb-0 body-2 font-weight-bold">{{ roomPlNumber ? 'LP' + roomPlNumber : '--' }}</p>
							<ProjectLineFilterMenu
								:chatRoom="chatRoom"
								:project_line_id.sync="project_line_id"
								:userProjects="userProjects"
								:conversationMessages="conversationMessages"
								@select-user-project="selectUserProject"
							/>
						</div>
					</div>
					<v-divider class="mr-2 white" style="opacity: 0.4;" vertical></v-divider>
					<div class="d-flex flex-column flex-grow-1 flex-1" style="width: 100%;">
						<div class="d-flex align-start justify-space-between flex-1 px-2" style="width: 100%;">
							<p class="mb-0 font-weight-bold mt-1" style="font-size: 10px;opacity: 0.9;">{{ getRoomType }}</p>
							<div>
								<v-btn icon small @click="toFullSizeChat(room)" class="flex-shrink-0">
									<v-icon small>mdi-open-in-app</v-icon>
								</v-btn>
								<v-btn icon small @click="$emit('minimize')" class="flex-shrink-0">
									<v-icon small>mdi-minus</v-icon>
								</v-btn>
								<v-btn icon small @click="$emit('close', room.id)" class="flex-shrink-0">
									<v-icon small>mdi-close</v-icon>
								</v-btn>
							</div>
						</div>
						<div class="d-flex align-center flex-grow-1" style="width: 100%;">
							<v-avatar size="30" :color="getRoomTypeIndicator === 'project_line' ? '#524d4d' : '#FF120B'" class="mr-2 flex-shrink-0">
								<img :src="chatRoom.morphable?.profile?.avatar" class="user-avatar" v-if="chatRoom.morphable?.profile?.avatar"/>
								<span v-else class="white--text font-weight-bold" style="font-size: 12px;">{{ chatRoom.name.charAt(0).toUpperCase() }}</span>
							</v-avatar>
							<div class="header-info mb-1" style="width: 100%;">
								<div class="d-flex align-start justify-space-between" style="width: 100%;">
									<div>
										<p class="mb-0 caption font-weight-bold">{{ roomName }}</p>
										<p class="mb-0" style="font-size: 11px;">{{ roomAddress }}</p>
										<p class="mb-0" style="font-size: 11px;" v-if="getRoomTypeIndicator === 'project_line'">Cliente: {{ projectLineClientName }}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Menu de líneas de proyecto -->
			</div>
			
			<div class="chat-body">
				<div v-if="fileToUpload || previewFile" class="d-flex flex-column flex-grow-1 fill-height" style="max-height: 100%;">
					<div class="d-flex align-center justify-space-between mb-2 py-1 px-2">
						<div class="d-flex align-center">
							<p class="mb-0 caption font-weight-bold">Previsualización Archivo</p>
						</div>
						<v-btn
							depressed
							color="#524D4D"
							icon
							class="ml-2"
							@click="closeFilePreview"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
					<FileViewer :selectedFile="fileToUpload || previewFile" />
					<div class="user-input-container" v-if="fileToUpload">
						<v-progress-linear indeterminate v-if="loadingAddChat"></v-progress-linear>
						<div class="user-input-inner-container">
							<v-text-field
								ref="messageInput"
								v-model="new_message"
								placeholder="Escribe un mensaje"
								hide-details
								dense
								outlined
								required
								class="custom-height-search custom-height-calendar"
								:disabled="loadingAddChat"
								@keydown.enter="sendMessage"
								@focus="chatFocused = true"
								@blur="chatFocused = false"
							>
								<template v-slot:append-outer>
									<v-btn small fab color="green" dark @click="sendMessage">
										<v-icon>mdi-send</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</div>
					</div>
				</div>
				<div v-else class="d-flex flex-column flex-grow-1" style="max-height: 100%;">
					<div ref="chatContainer" class="chat-container d-flex flex-column flex-grow-1">
						<div v-if="stickyRelatableMessage" class="d-flex align-center justify-center pt-1 mb-1" style="gap: 10px;background-color: #f2f2f2;position: sticky;top: 0;z-index: 10;">
							<p class="mb-1 caption font-weight-bold"><span class="text--secondary">[LP{{ getRelatableId(stickyRelatableMessage) }}]</span> {{getProjectLineName(stickyRelatableMessage.relatable?.relatable)}}</p>
							<ProjectLineAssociationMenu v-if="stickyRelatableMessage.relatable?.relatable_type == 'App\\Models\\ProjectLine'" :projectLineAssociations="getRelatableAssociations(stickyRelatableMessage)" />
						</div>
						<div class="messages-container" ref="messagesContainer" v-if="filteredMessages.length > 0">
							<div v-for="(message, index) in filteredMessages" :key="index" class="message-group d-flex flex-column">
								<v-divider v-if="shouldShowRelatableDivider(index)" class="my-1"></v-divider>
								<div v-if="message.system_message" class="system-message my-1">
									<div
										v-html="message.message"
										class="d-flex align-center justify-center" style="gap: 4px;">
									</div>
									<p class="mb-0 text-center">
										{{message.created_at | toDateTime}}
									</p>
								</div>
								<div v-else class="single-message my-1" :class="isMyMessage(message) ? 'self-user':''">
									<div class="d-flex align-center justify-space-between">
										<p v-if="!isMyMessage(message)" class="mb-0 font-weight-bold" style="font-size: 11px; line-height: 10px;" :style="{color: message?.user ? getUserColor(message.user.user_id) : 'inherit'}">{{getMessageName(message)}}</p>
									</div>
									<div
										v-if="message.file && getIconFile(message.file).icon != 'mdi-file-image'"
										class="chat-file-container rounded d-flex justify-center align-center pa-1"
										@click="previewFile = message.file"
									>
										<v-icon :color="getIconFile(message.file).color" large>{{getIconFile(message.file).icon}}</v-icon>
										<p class="mb-0 mt-2 caption text-center truncate-text">{{message.file.name}}</p>
									</div>
									<div v-else-if="message.file" @click="previewFile = message.file">
										<div class="chat-image-container mt-1">
											<v-img
												:src="message.file.file_link"
												contain
												width="200px"></v-img>
										</div>
									</div>

									<div class="d-flex align-start" v-if="message.message">
										<p class="mb-0 mr-4 mt-1" style="text-transform: none;">{{message?.message}}</p>
										<v-btn color="error" icon small v-if="isMyMessage(message) && !chatRoom.user_is_trashed" @click="deleteChatMessage(message.id)">
											<v-icon small>mdi-delete-outline</v-icon>
										</v-btn>
									</div>
									<div class="text-right caption text--secondary">
										<small>{{message.created_at | toDateTime}}</small>
									</div>
								</div>
							</div>
						</div>
						<div class="messages-container nomessages" v-else>
							<span v-if="project_line_id && !showAllMessages && !hasMessagesWithProjectLine">
								<div class="d-flex flex-column align-center">
									<p class="mb-1 font-weight-bold" style="font-size: 12px;">No hay mensajes</p>
								</div>
							</span>
							<span v-else style="font-size: 12px;">Escribe un mensaje</span>
						</div>
					</div>
					<div class="user-input-container text-center px-2 py-3" v-if="chatRoom.user_is_trashed">
						<p class="mb-0 caption text--secondary">No puedes enviar mensajes en este chat</p>
					</div>
					<div class="user-input-container" v-else>
						<v-progress-linear indeterminate v-if="loadingAddChat"></v-progress-linear>
						<div class="user-input-inner-container">
							<v-text-field
								ref="messageInput"
								v-model="new_message"
								placeholder="Escribe"
								hide-details
								dense
								outlined
								required
								:disabled="loadingAddChat"
								@keydown.enter="sendMessage"
								@focus="chatFocused = true"
								@blur="chatFocused = false"
							>
								<template v-slot:append-outer>
									<div class="px-1 py-0">
										<v-menu offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													small
													:loading="loadingAddChat"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small>mdi-paperclip</v-icon>
												</v-btn>
											</template>
											<v-list dense>
												<v-list-item @click="openProjectFileSelector">
													<v-list-item-icon class="mr-2">
														<v-icon small>mdi-folder-open</v-icon>
													</v-list-item-icon>
													<v-list-item-title>Desde archivos del proyecto</v-list-item-title>
												</v-list-item>
												<v-list-item @click="showFilePicker">
													<v-list-item-icon class="mr-2">
														<v-icon small>mdi-file</v-icon>
													</v-list-item-icon>
													<v-list-item-title>Desde mis archivos</v-list-item-title>
												</v-list-item>
											</v-list>
										</v-menu>
										<input 
											type="file" 
											ref="fileInput"
											style="display: none;"
											:accept="acceptedFileTypes"
										/>
									</div>
									<v-btn icon small @click="sendMessage">
										<v-icon small>mdi-send</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ChatProjectFileSelector
			v-if="showFileSelector && chatRoom?.morphable_id"
			:projectId="chatRoom.morphable_id"
			@file-selected="handleFileSelected"
		/>
	</div>
</template>

<script>
import {getChatRoomMessages, addMessageToChatRoom, chatFileToItem, deleteMessageFromChatRoom, markMessagesAsSeen} from '@/helpers/api/chats'
import FileViewer from '@/components/Views/PreProjects/Sections/FileViewer'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'
import ProjectLineFilterMenu from '@/components/Helpers/Components/Projectlinefiltermenu'
import ChatProjectFileSelector from '@/components/Views/Chat/Parts/ChatProjectFileSelector'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

export default {
	name: 'MessagesFullViewMini',
	components: {FileViewer, ProjectLineAssociationMenu, ProjectLineFilterMenu, ChatProjectFileSelector},
	props: {
		selectedChatRoomId: {
			type: Number,
			required: true
		},
		room: {
			type: Object,
			default: null
		},
		isExpanded: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			search: '',
			new_message: null,
			loadingAddChat: false,
			loadingRoomMessages: true,
			chatRoom: null,
			conversationMessages: [],
			requestInterval: null,
			fileToUpload: null,
			previewFile: null,
			menuOpen: false,
			project_line_id: null,
			showAllMessages: false,
			userProjects: null,
			chatFocused: false,
			showFileSelector: false,
			fileMenuOpen: false,
			userColorMap: {},
			colorPalette: [
				"#C92A2A",
				"#A61E4D",
				"#862E9C",
				"#5F3DC4",
				"#364FC7",
				"#1864AB",
				"#0B7285",
				"#087F5B",
				"#2B8A3E",
				"#5C940D",
				"#E67700",
				"#D9480F",
				"#B02A37",
				"#7B2CBF",
				"#3A0CA3",
				"#1D4ED8",
				"#1E40AF",
				"#155E75",
				"#065F46",
				"#166534",
				"#4D7C0F",
				"#92400E",
				"#9A3412",
				"#7F1D1D",
				"#701A75",
				"#4C1D95",
				"#1E3A8A",
				"#0C4A6E",
				"#134E4A",
				"#14532D"
			]
		};
	},
  computed: {
		isClient(){
			return this.$checkPermissions(['client_capabilities'])
		},
		isUserRoom(){
			return this.chatRoom.morphable_type == "App\\Models\\User"
		},
		filteredMessages(){
			if(!this.project_line_id || this.showAllMessages){
				return this.conversationMessages.filter(message => {
					return !message?.relatable
				})
			}
			return this.conversationMessages.filter(message => {
				return parseInt(message?.relatable?.relatable_id) === parseInt(this.project_line_id)
			})
		},
		hasMessagesWithProjectLine(){
			if(!this.project_line_id) return false
			return this.conversationMessages.some(message =>
				parseInt(message?.relatable?.relatable_id) === parseInt(this.project_line_id)
			)
		},
		otherProjectMessagesCount(){
			if(!this.project_line_id) return 0
			// Contar todos los mensajes que serían ocultados: sin relatable_id O con relatable_id diferente
			return this.conversationMessages.filter(message => {
				const rid = message?.relatable?.relatable_id
				return !rid || parseInt(rid) !== parseInt(this.project_line_id)
			}).length
		},
		getRoomTypeIndicator(){
			if(this.chatRoom.morphable?.associations?.every(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
				){
				return 'prospect'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id == 4){
				return 'client'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id != 4){
				return 'professional'
			}
			else if (this.chatRoom.morphable_type == "App\\Models\\ProjectLine"){
				return 'project_line'
			}
			return 'other'
		},
		getRoomType(){
			if(this.chatRoom.morphable?.associations?.every(assoc => {
																											const conv = assoc.morphable;
																											console.log('conv', conv)
																											return conv?.user && !conv?.client;
																										})
				){
				return 'Chat Prospecto'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id == 4){
				return 'Chat Cliente'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.capabilities?.subcontractor){
				return 'Chat Subcontratista'
			}
			else if(this.chatRoom.morphable_type == "App\\Models\\User" && this.chatRoom.morphable?.company_rol?.role_id != 4){
				return 'Chat Profesionales / Empresas'
			}
			else if (this.chatRoom.morphable_type == "App\\Models\\ProjectLine"){
				return 'Chat Grupal Proyecto'
			}
			return 'Otro'
		},
		roomName(){
			const project_line_number = this.chatRoom.morphable?.number

			if(this.chatRoom.name){
				return `${this.chatRoom.name}`
			}
			if(this.chatRoom.morphable_type == "App\\Models\\User"){
				return this.chatRoom.morphable.profile?.name + ' ' + this.chatRoom.morphable.profile?.lastname + ' ' + this.chatRoom.morphable.profile?.second_lastname
			}
			const project_name = this.chatRoom.morphable?.associations.reduce((acc, item) => {
				return acc || item.morphable.name || item.morphable.info?.project_details;
			}, null)
			return `${project_name} [LP${project_line_number}]`
		},
		roomAddress(){
			if(this.chatRoom.morphable_type == "App\\Models\\User"){
				return this.chatRoom.morphable.email
			}
			const project_address = this.chatRoom.morphable?.associations.reduce((acc, item) => {
				return acc || item.morphable?.info?.address?.address
			}, null)
			return project_address
		},
		queryRoute(){
			return this.$route.query
		},
    preproject() {
      return this.$store.state.preprojects.preProject
    },
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		roomAdmin(){
			return this.chatRoom.users.find((user) => user.admin == true)
		},
		acceptedFileTypes() {
			return [
				'application/pdf', 
				'application/msword', 
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 
				'application/vnd.ms-excel', 
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
				'image/jpeg', 
				'image/png', 
				'image/gif', 
				'image/bmp', 
				'image/svg+xml'
			].join(',');
		},
		projectLineClient(){
			return this.chatRoom.morphable?.associations?.find(assoc => 
				assoc.morphable?.client
			)?.morphable?.client
		},
		projectLineClientName(){
			const client = this.projectLineClient
			if(client){
				return client.profile?.name + ' ' + client.profile?.lastname + ' ' + client.profile?.second_lastname
			}
			return null
		},
		roomPlNumber(){
			return this.chatRoom.morphable?.number || this.selectedProjectLine?.number || null
		},
		selectedProjectLine(){
			const included_project_lines = this.chatRoom.included_project_lines.find(pl => pl.id == this.project_line_id)
			const other_project_lines = this.userProjects ? this.userProjects.find(pl => pl.id == this.project_line_id) : null
			return included_project_lines || other_project_lines
		},
		stickyRelatableMessage(){
			if(this.filteredMessages.length > 0 && this.filteredMessages[0]?.relatable){
				return this.filteredMessages[0]
			}
			return null
		}
  },
	watch: {
		filteredMessages(newValue){
			if (newValue && newValue.length > 0) {
				const unseenMessageIds = newValue
					.filter(msg => msg.id && (!msg.seen_message || msg.seen_message.length === 0))
					.map(msg => msg.id);
				
				if (unseenMessageIds.length > 0 && this.isExpanded) {
					this.markMessagesAsSeenBatch(unseenMessageIds);
				}
				// this.$emit('unseenMessageCount', unseenMessageIds.length, this.chatRoom.id);
			}
			this.$nextTick(() => {
				this.scrollToBottom()
			})
		},
		isExpanded(newValue){
			if (newValue) {
				const unseenMessageIds = this.filteredMessages
					.filter(msg => msg.id && (!msg.seen_message || msg.seen_message.length === 0))
					.map(msg => msg.id);
				if (unseenMessageIds.length > 0) {
					this.markMessagesAsSeenBatch(unseenMessageIds);
				}
			} else {
				this.reloadChatRoom();
			}
		},
		queryRoute(){
			const chat_room_id = this.$route.query.id
			if(chat_room_id && this.selectedChatRoomId == chat_room_id){
				this.getSelectedChatRoomMessages()
			}
		},
		chatsRooms(newValue){
			if(newValue && newValue.length > 0 && parseInt(this.$route.query.user_id)){
				this.selectRoomFromSearch({id: parseInt(this.$route.query.user_id)})
			}
		},
		conversationMessages(newValue){
			if(newValue){
				this.scrollToBottom()
			}
			if(newValue && newValue.length > 0){
				const unseenMessageIds = newValue
					.filter(msg => !msg.seen_message || msg.seen_message.length === 0)
					.map(msg => msg.id);
				this.$emit('unseenMessageCount', unseenMessageIds.length, this.chatRoom.id);
			}
		},
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('chats/getUserChats')
				this.$store.dispatch('users/getUserFromCompany', {start: 0, limit: 300})
			}
		},
		selectedChatRoomId(newValue, oldValue){
			if(newValue && newValue != oldValue){
				this.getSelectedChatRoomMessages()
			}
		}
	},
	beforeDestroy(){
		eventBus.$off('reloadChat', this._onReloadChat)
		eventBus.$off('attention-chat-room', this._onReloadChat)
	},
	mounted(){
		this.scrollToBottom()
		const projectLineId = this.$route.query.project_line_id || this.$route.params.project_line_id || this.room.project_line_id || null
		this.project_line_id = projectLineId ? parseInt(projectLineId) : null
		if(this.selectedCompany){
			this.$store.dispatch('chats/getUserChats')
			this.$store.dispatch('users/getUserFromCompany', {start: 0, limit: 300})
		}
		
		if(this.selectedChatRoomId){
			this.getSelectedChatRoomMessages()
		}
    eventBus.$on('reloadChat', this._onReloadChat)
		eventBus.$on('attention-chat-room', this._onOpenningChatRoom)
	},
	methods: {
		assignColorsToUsers(users) {
			localStorage.removeItem('chatUserColorMap_' + this.chatRoom.id)
			// const colorMap = localStorage.getItem('chatUserColorMap_' + this.chatRoom.id)
			// if (colorMap) {
			// 	this.userColorMap = JSON.parse(colorMap)
			// 	return
			// }
			const sorted = [...users].sort((a, b) => a.user_id - b.user_id)
			const newMap = {}
			const availableColors = [...this.colorPalette];
			sorted.forEach(user => {
				if (user && user.user_id && availableColors.length) {
					if(this.projectLineClient && user.user_id === this.projectLineClient.id){
						newMap[user.user_id] = 'black'
						return
					}
					const index = Math.floor(Math.random() * availableColors.length);
					newMap[user.user_id] = availableColors.splice(index, 1)[0];
				}
			});
			this.userColorMap = newMap
			localStorage.setItem('chatUserColorMap_' + this.chatRoom.id, JSON.stringify(newMap))
		},
		getUserColor(userId) {
			return this.userColorMap[userId] || '#9E9E9E'
		},
		_onOpenningChatRoom({ chat_room_id }) {
			if (this.selectedChatRoomId == chat_room_id) {
				this.$emit('expand')
				this.$refs.mainContainerMiniChat.classList.add('alert');
				setTimeout(() => {
					this.$refs.mainContainerMiniChat.classList.remove('alert');
				}, 540);
			}
		},
		toFullSizeChat(room){
			this.$router.push({ name: 'Chat', params: { id: room.id } })
			this.$emit('close', room.id)
		},
		getUnseenMessageCountForProjectLine(projectLineId){
			if(!this.conversationMessages || this.conversationMessages?.length === 0) return 0
			return this.conversationMessages
				.filter(msg => {
					return parseInt(msg?.relatable?.relatable_id) === parseInt(projectLineId) && (!msg.seen_message || msg.seen_message.length === 0)
				})
				.length
		},
		getProjectLineName(pl){
			const assoc = pl.associations?.find(assoc => assoc.morphable?.name || assoc.morphable?.info?.project_detail);
			return assoc?.morphable?.name || assoc?.morphable?.info?.project_detail || '--';
		},
		reloadChatRoom(){
			this.getSelectedChatRoomMessages()
		},
		selectUserProject(pl){
			this.project_line_id = pl.id
		},
		clearProjectLineFilter(){
			this.project_line_id = null
			this.showAllMessages = false
			const query = { ...this.$route.query }
			delete query.project_line_id
			this.$router.replace({ query })
		},
		getRelatableId(message){
			return message?.relatable?.relatable_id || null
		},
		getRelatableAssociations(message){
			if(message?.relatable?.relatable?.associations){
				return {
					associations: message.relatable.relatable.associations,
					project_line_id: message.relatable.relatable.id
				}
			}
			return null
		},
		shouldShowRelatableHeader(index){
			// Cuando hay un filtro activo con mensajes coincidentes, mostrar header solo al inicio
			if(this.project_line_id && !this.showAllMessages && this.hasMessagesWithProjectLine){
				return index === 0;
			}
			
			const currentMessage = this.filteredMessages[index];
			const previousMessage = index > 0 ? this.filteredMessages[index - 1] : null;
			
			const currentRelatableId = this.getRelatableId(currentMessage);
			const previousRelatableId = previousMessage ? this.getRelatableId(previousMessage) : null;
			
			// Mostrar header si el mensaje actual tiene relatable y el id cambió respecto al anterior
			return !!currentRelatableId && currentRelatableId !== previousRelatableId;
		},
		shouldShowRelatableDivider(index){
			// Cuando hay un filtro activo con mensajes coincidentes, nunca mostrar divisores
			if(this.project_line_id && !this.showAllMessages && this.hasMessagesWithProjectLine){
				return false;
			}
			
			const currentMessage = this.filteredMessages[index];
			const previousMessage = index > 0 ? this.filteredMessages[index - 1] : null;
			
			if (index === 0 || !previousMessage) return false;
			
			const currentRelatableId = this.getRelatableId(currentMessage);
			const previousRelatableId = this.getRelatableId(previousMessage);
			
			// Mostrar divisor si el relatable_id cambió
			return currentRelatableId !== previousRelatableId;
		},
		getMessageName(message){
			if(message?.user){
				return message?.user?.name + ' ' + message?.user?.lastname + ' ' + message?.user?.second_lastname
			}
			return this.roomName
		},
		_onReloadChat() {
			if(this.selectedChatRoomId){
				this.getSelectedChatRoomMessages()
			}
		},
		scrollToBottom() {
			this.$nextTick(() => {
				const container = this.$refs.chatContainer;
				if (container) {
					container.scrollTop = container.scrollHeight;
				}
			})
		},
		closeFilePreview(){
			this.fileToUpload = null
			this.previewFile = null
		},
		openProjectFileSelector(){
			if (this.chatRoom?.morphable_id) {
				this.showFileSelector = true
			} else {
				const messageData = {
					message: 'No se pudo identificar el proyecto asociado',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async handleFileSelected(file){
			const data = {
				chat_room_id: this.selectedChatRoomId,
				message: '',
				file_id: file.id
			}
			if(this.project_line_id){
				data.relatable_type = 'project_line'
				data.relatable_id = this.project_line_id
			}
			const formData = new FormData()
			Object.keys(data).forEach((key) => {
				if(data[key]) {
					formData.append(key, data[key])
				}
			})
			
			this.new_message = null
			const new_message = await addMessageToChatRoom(formData)
			if(new_message.code == 200){
				this.conversationMessages = new_message.chat_room_messages
				this.$store.dispatch('chats/getUserChats')
				this.getSelectedChatRoomMessages()
				this.closeFilePreview()
			}
		},
		getIconFile(file){
			const fileExtension = file.path.split('.').pop().toLowerCase();
			if (fileExtension === 'pdf') {
					return { icon: 'mdi-file-pdf-box', color: '#FF0000' };
			} else if (fileExtension === 'doc' || fileExtension === 'docx') {
					return { icon: 'mdi-file-word', color: '#1E88E5' };
			} else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
					return { icon: 'mdi-file-excel', color: '#4CAF50' };
			} else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(fileExtension)) {
					return { icon: 'mdi-file-image', color: '#FFD700' };
			} else {
					return { icon: 'mdi-file', color: '#9E9E9E' };
			}
		},
		showFilePicker() {
			const input = this.$refs.fileInput;
			input.onchange = async (event) => {
				const file = event.target.files[0]
				this.fileToUpload = file
				input.value = null
			};
			input.click();
		},
		isMyMessage(message){
			return message.user_id == this.$store.state.user?.userInfo?.id
		},
		async markMessagesAsSeenBatch(messageIds) {
			try {
				await markMessagesAsSeen({
					chat_room_id: this.selectedChatRoomId,
					message_ids: messageIds
				});
				this.reloadChatRoom();
			} catch (error) {
				console.log('Error marking messages as seen:', error);
			}
		},
		async getSelectedChatRoomMessages(){
			this.closeFilePreview()
			this.showAllMessages = false
			const chat_room_id = this.selectedChatRoomId
			const messages = await getChatRoomMessages({chat_room_id, project_line_id: this.project_line_id})
			this.loadingRoomMessages = false
			if(messages.code == 200){
				this.conversationMessages = messages.chat_room?.messages;
				this.chatRoom = messages.chat_room;
				this.userProjects = messages.user_projects;
				this.$emit('onRoomInfo', this.chatRoom)
				if(this.chatRoom?.users && this.chatRoom.users.length > 0) {
					this.assignColorsToUsers(this.chatRoom.users)
				}
			}
			else if(messages.code == 403){
				this.$store.dispatch('chats/getUserChats')
				this.$emit('clearSelectedRoom')
				this.$emit('close', chat_room_id)

				const messageData = {
					message: 'No tienes acceso a este chat',
					title: 'Sin acceso',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async sendMessage(){
			if(this.new_message || this.fileToUpload){
				this.appendNewMessageTemp(this.new_message)
				const data = {
					chat_room_id: this.selectedChatRoomId,
					message: this.new_message,
					file: this.fileToUpload
				}
				if(this.project_line_id){
					data.relatable_type = 'project_line'
					data.relatable_id = this.project_line_id
				}
        const formData = new FormData()
        Object.keys(data).forEach((key) => {
          if(data[key]) {
            formData.append(key, data[key])
          }
        })
				this.new_message = null
				const new_message = await addMessageToChatRoom(formData)
				if(new_message.code == 200){
					this.conversationMessages = new_message.chat_room_messages
					this.$store.dispatch('chats/getUserChats')
					this.getSelectedChatRoomMessages()
					this.closeFilePreview()
				}
			}
		},
		appendNewMessageTemp(message){
			let add_message = {
				message,
				user: {
					name: this.$store.state.user?.userInfo?.profile?.name,
					lastname: this.$store.state.user?.userInfo?.profile?.lastname,
					second_lastname: this.$store.state.user?.userInfo?.profile?.second_lastname,
				},
				user_id: this.$store.state.user?.userInfo?.id
			}
			if(this.project_line_id){
				add_message.relatable = {
					relatable_id: this.project_line_id
				}
			}
			this.conversationMessages.push(add_message)
		},
		async fileToItem(file_id){
			const data = {
				chat_room_id: this.selectedChatRoomId,
				file_id
			}
			try {
				await chatFileToItem(data)
				this.getSelectedChatRoomMessages()
				const messageData = {
					message: 'Se ha asociado el archivo al preproyecto',
					title: 'Archivo guardado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			} catch (error) {
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async deleteChatMessage(message_id){
			const messageIndex = this.conversationMessages.findIndex(msg => msg.id === message_id)
			const originalMessage = messageIndex >= 0 ? { ...this.conversationMessages[messageIndex] } : null
			
			if (messageIndex >= 0) {
				this.conversationMessages.splice(messageIndex, 1)
			}
			
			try {
				await deleteMessageFromChatRoom({message_id})
			} catch (error) {
				if (originalMessage && messageIndex >= 0) {
					this.conversationMessages.splice(messageIndex, 0, originalMessage)
				}
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
	},
};
</script>

<style scoped>
	.relatable-header {
		padding: 10px;
		margin-top: 8px;
		margin-bottom: 4px;
	}
	.relatable-chip {
		display: flex;
		align-items: center;
		gap: 4px;
	}
	.chat-container{
		flex: 1;
		min-height: 0;
		overflow: auto;
	}
	.chat-list-item{
		cursor: pointer;
	}
	.chat-list-item:hover{
		background: #FCFBFE;
	}

	.v-text-field {
		align-items: center;
	}
	.chatbox-container{
		display: flex;
		flex-direction: column;
		background: white;
	}
	.messages-container{
		display: flex;
		flex-direction: column;
		padding: 10px;
		background-color: #FCFBFE;
		text-transform: none;
	}
	.chat-room-header,
	.user-input-container{
		flex: 0;
		background-color: #e9e9e9;
	}
	.hidden-messages-bar {
		flex: 0;
		background-color: #fff3cd;
		border-top: 1px solid #ffc107;
		border-bottom: 1px solid #ffc107;
	}
	.user-input-inner-container{
		padding: 10px;
	}
	.single-message{
		background-color: rgb(237, 237, 237);
		border: 1px solid rgb(193, 191, 191);
		padding: 4px 8px;
		max-width: 80%;
		border-radius: 10px;
		font-size: 14px;
		margin-bottom: 8px;
		text-transform: none;
		overflow-wrap: break-word;
		word-break: break-word;
		word-wrap: break-word;
	}
	.single-message.self-user{
		background-color: rgb(217, 239, 217);
		border: 1px solid rgb(197, 232, 197);
		align-self: flex-end;
	}
	.chatbox-container .single-message p{
		margin-bottom: 0;
		word-break: break-word;
		overflow-wrap: break-word;
		word-wrap: break-word;
		white-space: normal;
		max-width: 100%;
	}
	.single-message .d-flex {
		min-width: 0;
	}
	.nomessages{
		text-align: center;
		font-size: 14px;
		padding-top: 30px;
	}
	.chat-file-container{
		cursor: pointer;
		background: rgba(0,0,0,0.1);
	}
	.chat-image-container{
		cursor: pointer;
	}
	.custom-badge-counter-chat{
		position: absolute;
		top: -15px;
		right: -8px;
		background-color: green;
		z-index: 100;
		border-radius: 50%;
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.chat-header {
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		background: linear-gradient(135deg, #6c6a6a 0%, #524d4d 100%);
		color: white;
		padding: 2px 10x;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: start;
		flex-shrink: 0;
		gap: 0px;
	}
	.chat-header.project-line-header {
		background: #FF120B;
	}
	.chat-header p {
		color: white;
	}
	.chat-header .v-btn {
		color: white !important;
	}
	.header-info {
		min-width: 0;
		overflow: hidden;
	}
	.chat-body {
		flex: 1;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}
	.active-item {
		background-color: rgba(255, 18, 11, 0.1) !important;
	}
	.messages-full-view-mini:hover,
	.messages-full-view-mini.chat-focused {
		box-shadow: 0 0 0 2px #FF120B;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
	}
	.messages-full-view-mini.alert {
		animation: shakeScale 0.5s;
		box-shadow: 0 0 0 2px #FF120B;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
	}
	.system-message{
		font-size: 11px;
		color: #555;
		background-color: #f0f0f0;
		border: 1px solid #ddd;
		border-radius: 5px;
		padding: 2px 8px;
		gap: 4px;
		width: fit-content;
		margin: auto;
	}

	@keyframes shakeScale {
		0%   { transform: scale(1) translateX(0); }

		20%  { transform: scale(1.02) translateX(-3px); }
		40%  { transform: scale(1.03) translateX(3px); }
		60%  { transform: scale(1.02) translateX(-2px); }
		80%  { transform: scale(1.01) translateX(2px); }

		100% { transform: scale(1) translateX(0); }
	}
</style>